import DatasetImage from "./DatasetImage";

export default DatasetImage;
